import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ResourceImageInfoDto } from './ResourceImageInfoDto'
/**
* Class ProductAttributeValueDto
*  Информация о значении атрибута
*/
export class ProductAttributeValueDto extends ActiveModel {

/**
  * value
  * 
  */
  @ActiveField()
  value?: string


/**
  * displayName
  * Если значением атрибута является значение словаря, то содержит человеко-читаемое значение<br>
  */
  @ActiveField()
  displayName?: null | string


  /**
  * displayOrder
  * Если значением атрибута является значение словаря, то содержит порядковый номер отображения значения<br>  */
  @ActiveField()
  displayOrder?: null | number


  /**
  * imageInfo
  * Если значением атрибута является значение файла-изображения, то содержит информацию об изображении<br>  */
  @ActiveField({
    factory: [ResourceImageInfoDto, () => undefined]
  })
  imageInfo?: null | ResourceImageInfoDto
}
